import axiosPost from "./axiosPost";

export const CargoGet= async (credentials, data) => {
    const body = {
        service: "CargoGet",
        params: {
            cargoId: data.cargoId,
            cargoCod: data.cargoCod,
        },
    };    
    try {
        
        const response = await axiosPost("Y", body, credentials)
        return response;
    } catch (err) {
        console.error(`Error: ${err}`);
    }
}